import styled from 'styled-components';

import { SkeletonElement, theme } from '@notino/react-styleguide-v20';

export const StyledTitle = styled(SkeletonElement)`
  height: 1.25rem;
  margin-bottom: 0.75rem;
`;

export const StyledLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.color.border.disabled};
  margin: 1rem 0;
`;
